import React from 'react';

export type DividerProps = React.HTMLAttributes<HTMLDivElement> & {
  orientation?: 'horizontal' | 'vertical';
};

export const Divider: React.FC<DividerProps> = ({
  orientation = 'horizontal',
  className = '',
  ...rest
}) => (
  <div
    className={`${orientation === 'vertical' ? 'divider-v' : 'divider'} ${className}`}
    {...rest}
  />
);
